<app-multiple-select
    [datasourceColumnId]="dashboardItem.datasourceColumnId"
    [dataLoaderData]="dataLoaderResult"
    [excludeMode]="isExcludeMode()"
    [splitable]="isSplitable()"
    [showQuickSelectionButtons]="isQuickSelectionButtons()"
    [selectMode]="dashboardItem.selectMode"
>
</app-multiple-select>
